// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".velocity-vision-page-velocityVisionPageContainer--1b2wHZLeWCQ09XhN2orqdo{display:flex;flex-flow:column;height:calc(100vh - 108px)}", "",{"version":3,"sources":["webpack://src/pages/VelocityVision/velocityVisionPage.module.scss"],"names":[],"mappings":"AAAA,0EACC,YAAA,CACA,gBAAA,CACA,0BAAA","sourcesContent":[".velocityVisionPageContainer {\r\n\tdisplay: flex;\r\n\tflex-flow: column;\r\n\theight: calc(100vh - 108px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"velocityVisionPageContainer": "velocity-vision-page-velocityVisionPageContainer--1b2wHZLeWCQ09XhN2orqdo"
};
export default ___CSS_LOADER_EXPORT___;
